export const FLIGHTS_COUNTER = 'FLIGHTS';

export const FLIGHT_SECONDS_COUNTER = 'FLIGHT_SECONDS';
